import React, { useEffect, useState } from "react";
import AgentHeader from "../../components/agent-ui/AgentHeader";
import "./dev.css";
import { useNavigate } from "react-router-dom";
import Overlay from "../../components/overlay/Overlay";
import EditPopup from "../../utils/EditPopup";
import { AxiosAuthGet, AxiosAuthPut } from "../../api/api";
import { Btn, SuccessComp } from "../../utils/utils";
import estImg from "../../assets/est_img.png";
import Loading from "../../components/ui/Loading";
import Pagination from "../../utils/pagination";

const DevEstateView = () => {
  const [estId, setEstId] = useState("");
  const url = `developer/estates/${estId}/`;
    const [curPage, setCurPage] = useState(1);
    const [pag, setPag] = useState();
  const estUrl = `developer/estates/?page=${curPage}&page_size=10`;
  const navigate = useNavigate();
  const [isEdit, setIsEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isELoading, setIsELoading] = useState(false);
  const [estateName, setEstateName] = useState("");
  const [estateArr, setEstateArr] = useState();
  const [sucMsg, setSucMsg] = useState("");
  // const [errMsg, setErrMsg] = useState("");


  const dataChange = (e) => {
    setEstateName(e.target.value);
  };

  const dataSet = {
    name: estateName,
  };

  const submitChange = () => {
    setIsLoading(true);
    AxiosAuthPut(url, dataSet)
      .then((res) => {
        // console.log(res);
        setSucMsg(res.message);
        setTimeout(() => {
          setSucMsg("");
          setIsEdit(false);
          window.location.reload();
        }, 2000);
        setIsLoading(false);
      })
      .catch((err) => {
        // console.log(err.response);
        setIsLoading(false);
      });
  };

  const getEst = () => {
    setIsELoading(true);
    AxiosAuthGet(estUrl)
      .then((res) => {
        // console.log(res);
        setEstateArr(res?.data);
        setIsELoading(false);
        setPag(res.pagination);
      })
      .catch((err) => {
        // console.log(err.response);
        setIsELoading(false);
      });
  };

  const addEst = () => {
    navigate("/dev_dash/estate/estate-add/");
  };

  const editEst = (item) => {
    setEstateName(item?.name);
    setEstId(item?.id);
    setIsEdit(!isEdit);
  };
  
  const clickNext = () => {
    setCurPage(pag?.nextPage);
  };
  const clickPrev = () => {
    setCurPage(pag?.previousPage);
  };

  useEffect(() => {
    getEst();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    // eslint-disable-next-line
  }, []);

  return (
    <div style={{ position: "relative" }}>
      <SuccessComp message={sucMsg} />
      {isEdit && <Overlay />}
      <EditPopup
        isEdit={isEdit}
        setIsEdit={setIsEdit}
        editBtn={submitChange}
        estate={estateName}
        changeInput={dataChange}
        // err={errMsg}
        loading={isLoading}
      />
      <AgentHeader
        header={"Estates"}
        btnText={"Add Estate"}
        btnClick={addEst}
      />
      {isELoading && <Loading /> }
      {!isELoading && <div className="estates_houses" style={{flexWrap: "wrap"}}>
        {estateArr?.map((item, idx) => {
          return (
            <div key={idx} className="each_est">
              <img src={item?.pictures?.[0]?.link || estImg} alt="estate-image" />
              <h3>{item?.name}</h3>
              <p>{item?.city + ", " + item?.state + ", " + item?.country}</p>
              <div className="est_hus_btn">
                <Btn
                  btnClick={() => editEst(item)}
                  btnText={"Edit"}
                  btnClass={"btn_blk_txt"}
                  btnWidth={"100%"}
                />
              </div>
              <div className="est_hus_btn">
                <Btn
                  btnClick={() => {}}
                  btnText={"Delete"}
                  btnClass={"btn_col"}
                  btnWidth={"100%"}
                />
              </div>
              {/* <p>{item?.name}</p>
              <Edit color="#F08228" size={16} /> */}
            </div>
          );
        })}
            {pag && (
              <Pagination
                clickNext={clickNext}
                clickPrev={clickPrev}
                pagData={pag}
              />
            )}
      </div>}
    </div>
  );
};

export default DevEstateView;
